__turbopack_context__.v({
  "reviewList": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewList",
  "reviewSkeleton": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewSkeleton",
  "reviewSkeletonFooter": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewSkeletonFooter",
  "reviewSkeletonHeader": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewSkeletonHeader",
  "reviewSkeletonMediaTab": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewSkeletonMediaTab",
  "reviewSkeletonMediaTabs": "ProductReviewListSkeleton-module-scss-module__Uaj5kq__reviewSkeletonMediaTabs",
});
